module.exports = "/assets/7785fe3bb99b2ea350040513e35281b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/2V.png
// module id = 2128
// module chunks = 0